"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
exports.numberChoices = numberChoices;
var _objectSpread2 = _interopRequireDefault(require("/Users/robertvunabandi/Desktop/Projects/aidos-server-python/node_modules/@babel/runtime/helpers/esm/objectSpread2.js"));
var React = _interopRequireWildcard(require("react"));
var stylex = _interopRequireWildcard(require("@stylexjs/stylex"));
var _perfViewsStyles = require("web/shared/telemetry/perfViews.styles.js");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
* A row of choices with one of them current.
*
* The console's one kind of control: every choice a view offers is the same
* gesture, so one component.
*
* A row of buttons rather than a select: the choices are few, and the whole
* point of these is to be flicked between while watching the chart change,
* which a menu that closes on every pick prevents.
*/
function ChoicePicker(_ref) {
  let options = _ref.options,
    selected = _ref.selected,
    onPick = _ref.onPick;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: options.map(option => /*#__PURE__*/(0, _jsxRuntime.jsx)("button", (0, _objectSpread2.default)((0, _objectSpread2.default)({
      type: "button",
      onClick: () => onPick(option.value)
    }, stylex.props(_perfViewsStyles.styles.button, option.value === selected && _perfViewsStyles.styles.buttonActive)), {}, {
      children: option.label
    }), String(option.value)))
  });
} /** The numeric choices a picker takes, labelled by the number itself. */
function numberChoices(values, label) {
  return values.map(value => ({
    value,
    label: label(value)
  }));
}
var _default = exports.default = ChoicePicker;